import * as React from 'react';
import { useState, useEffect } from 'react';

import styled from 'styled-components';

import { Modal, ModalButtonGroup } from '../Common/Modal/modal';
import { ModernButton } from '../Common/modern-button';

interface SessionTimeoutModalProps {
    durationMs?: number;
    timerIntervalMs?: number;
    onTimerDone?: () => void;
    onLogOut: () => void;
    onContinue: () => void;
}

const StyledP = styled.p`
    margin-bottom: 30px;
    line-height: normal;
`;

export const SessionTimeoutModal: React.FC<React.PropsWithChildren<SessionTimeoutModalProps>> = ({
    durationMs = 1 * 60 * 1000,
    timerIntervalMs = 1000,
    onTimerDone,
    onLogOut,
    onContinue,
}) => {
    const [timer, setTimer] = useState<number>(durationMs);

    useEffect(() => {
        const timerId = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer - timerIntervalMs > 1000) {
                    return prevTimer - timerIntervalMs;
                } else {
                    clearInterval(timerId);
                    onTimerDone && onTimerDone();
                    return 1000;
                }
            });
        }, timerIntervalMs);

        return () => {
            clearInterval(timerId);
        };
    }, [timerIntervalMs, onTimerDone]);

    const seconds = Math.floor(timer / 1000);

    return (
        <Modal
            title={'You are about to be signed out'}
            hasCloseButton={false}
            dataId={'session-timeout-modal'}
            buttons={
                <ModalButtonGroup>
                    <ModernButton
                        onClick={onLogOut}
                        category={'secondary'}
                        dataId={'session-timeout-modal__log-out-button'}
                    >
                        Log out
                    </ModernButton>
                    <ModernButton
                        onClick={onContinue}
                        category={'primary'}
                        dataId={'session-timeout-modal__continue-button'}
                    >
                        Continue
                    </ModernButton>
                </ModalButtonGroup>
            }
        >
            <StyledP>You are about to be signed out of Spotlight due to inactivity.</StyledP>
            <StyledP>
                To continue using Spotlight, click the {`'Continue'`} button below in the next {seconds} second
                {seconds > 1 && 's'}.
            </StyledP>
        </Modal>
    );
};
